import { render, staticRenderFns } from "./vr-roam.vue?vue&type=template&id=1526248e&scoped=true&lang=html"
import script from "./vr-roam.vue?vue&type=script&lang=js"
export * from "./vr-roam.vue?vue&type=script&lang=js"
import style0 from "./vr-roam.vue?vue&type=style&index=0&id=1526248e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1526248e",
  null
  
)

export default component.exports